<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="ded"></a>
<p class="dedication" id="ded_p1">Dedicated to the memory of my good friend the gibbon Bubu, died at Port Dickson, Malaya, 12 July 1962.</p>
<a id="page_2"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication1.vue?47d3f5ec